import React from 'react';
import * as css from './SummaryStats.css';
import _ from 'lodash';
import {formatNumber} from '../../../../library/numberFunction';

function SummaryStats({summaryKeysList, summaryData, t}) {
    return (
        <css.summaryStats>
            {summaryKeysList.map((field, index) => (
                _.has(summaryData, field.key) && (
                    <css.summaryStatItem key={field.key}>
                        {t(field.label)}: {formatNumber(summaryData[field.key])}{field.suffix}
                    </css.summaryStatItem>
                )
            ))}
        </css.summaryStats>
    );
}

export default SummaryStats;